import { InjectionToken } from '@angular/core';

export const TEST_ABO_WIDGET_CONTENT_URL = new InjectionToken<string>('Test-abo widget content');
